<div class="dialog-wrappers">
  <div class="display-flex padding-dialog dialog-header">
    <div class="float-left">
      <div class="dialog-header-title">        
        <h1>Conversation</h1>
      </div>      
    </div>
    <div class="float-right">
      <span class="close-dialog" (click)="closeDialog()"><img src="../../../assets/icons/icon-close.png" alt="Close" width="16" /></span>
     </div>
   </div>

  <!-- <div class="dialog-header">
    <button class="bttn close-button" (click)="closeDialog()">Close</button>
  </div> -->
  <mat-dialog-content>
    <div class="padding-dialog">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" class="feedback-tab-group" animationDuration="0ms">
      <mat-tab label="Conversation details" *ngIf="!hideConversationTab">
        <ng-template matTabContent>
          <div class="tab-content">
            <app-abiomed-chat [isDialogMode]="true" [chatSessionId]="chatSessionId" [feedbackId]="feedbackId"
              [highlightUserQuery]="userRequest" [historyFrom]="'feedback'">
            </app-abiomed-chat>
          </div>
        </ng-template>
      </mat-tab>

      <mat-tab label="Response Evaluation">
        <ng-template matTabContent>
          <div class="tab-content">
            <app-evaluate-feedback [feedbackId]="feedbackId" [selectedTabIndex]="selectedEvaluationTabIndex"
              [targetTabLabel]="targetEvaluationTabLabel">
            </app-evaluate-feedback>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    </div>
  </mat-dialog-content>
</div>